import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/all";

export const initGSAP = () => {
  /**
   * Deactivates GSAP if user have this option enabled in the browser.
   * - Can be tested by activating reduced-motion.
   * - Chrome prefer reduced motion:
        Using Chrome DevTools's Command Menu:
        Open Chrome DevTools and press Ctrl + Shift + P on Windows/Linux or Cmd + Shift + P on macOS to open the Command Menu;
        Type reduced to filter available commands;
        Select the emulate CSS prefers-reduced-motion option, and then press Enter to toggle the emulation on/off;
    */
  if (document.body.classList.contains("prefers-reduced-motion") != true) {
    gsap.registerPlugin(ScrollTrigger);
    /**
 * Scroll on History-block
 * - When the user is on the History-block, and on a desktop.
 */
    const historyBlocks = document.querySelectorAll(".history-block");
    const isDesktop = window.innerWidth >= 900;

    if (isDesktop) {
      const historySectionActive = "history-section--active";

      historyBlocks.forEach((historyBlock) => {
        const historySections = Array.from(historyBlock.querySelectorAll(".history-section"));

        historySections.forEach((section, index) => {
          if (index == 0) {
            ScrollTrigger.create({
              trigger: historyBlock,
              start: "top center",
              end: "50px",
              markers: false, // Set to true when working with the trigger positions.
              onEnter: () => {
                // Handle entering a section
                // Remove active class from all sections and add to this section
                historySections.forEach((sec) => sec.classList.remove(historySectionActive));
                section.classList.add(historySectionActive);
              },
              onLeaveBack: () => {
                // Handle leaving a section in reverse direction.
                // Remove active class from all sections and add to the previous section.
                historySections.forEach((sec) => sec.classList.remove(historySectionActive));

                // Only possible to go backward if you've already gone forward.
                if (index > 0) {
                  historySections[index - 1].classList.add(historySectionActive);
                }
              },
            });
          } else {
            ScrollTrigger.create({
              trigger: section,
              start: "center center",
              end: "center center",
              markers: false, // Set to true when working with the trigger positions.
              onEnter: () => {
                // Handle entering a section.
                // Remove active class from all sections and add to this section.
                historySections.forEach((sec) => sec.classList.remove(historySectionActive));
                section.classList.add(historySectionActive);
              },
              onLeaveBack: () => {
                // Handle leaving a section in reverse direction.
                // Remove active class from all sections and add to the previous section.
                historySections.forEach((sec) => sec.classList.remove(historySectionActive));
                historySections[index - 1].classList.add(historySectionActive);
              },
            });
          }
        });
      });
    }

    /**
   * GSAP scroll animation
   * - All classes of with the specified class will get the animation on scroll.
   * - Only on desktop due to older Safari/iPhone does not support this.
   */
    if (window.innerWidth >= 900) {
      const sections = gsap.utils.toArray('.animation');
      sections.forEach((section) => {
        gsap.set(section, { y: 100, opacity: 0 });
        ScrollTrigger.create({
          trigger: section,
          start: 'top bottom-=50',
          end: () => `+=${section.clientHeight}`,
          markers: false,
          onEnter: () => {
            section.classList.add('in-view');
            gsap.to(section, { y: 0, opacity: 1 });
          },
        });
      });
    }
  }
}